module.exports = function() {
  return new Worker(__webpack_public_path__ + "226f9352d27cbdb1d908.worker.js");
};